export default "__VITE_ASSET__CT5qjI0Z__"